
import Select from 'react-select'
import React, { useEffect, useState } from 'react'
import Header from '../../../../../Components/Header/Header'
import Sidebar from '../../../../../Components/Sidebar/Sidebar'
import DeletePopup from '../../GardenPopup/DeletePopup'
import STPMachineryDetailsMasterPopup from './STPMachineryDetailsMasterPopup'

export default function STPMachineryDetailsMasterData() {

    const [DeletePopupShow, setDeletePopupShow] = useState()
    const [STPMachineryDetailsMasterPopupShow, setSTPMachineryDetailsMasterPopupShow] = useState()
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')

    const [Ward, setWard] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [MachEquipmentType, setMachEquipmentType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [MachineryDetails, setMachineryDetails] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const handleAddOnClick = () => {
        console.log("add")
        setSTPMachineryDetailsMasterPopupShow(true)
    }

    const handleEditOnClick = (item) => {
        setSTPMachineryDetailsMasterPopupShow(true)
        setapiFlag('Update')
        setrowData()
    }

    const handleOnCloseClick = () => {
        setSTPMachineryDetailsMasterPopupShow(false)
    }

    // const handleIsSearch = () => {
    //     setIsSearch(!IsSearch)
    //     setCurrentPage(0)
    // }

    // const handleClear = () => {
    //     setCurrentPage(0)
    //     setIsClear(!IsClear)
    //     setWorkName('')
    // }

    // const handleClear = () => {
    //     // setCurrentPage(0)
    //     // setIsClear(!IsClear)

    //     setWardName({
    //         ...WardName,
    //         ID: 0,
    //         Label: 'Select...',
    //     })
    //     // console.log("call")
    // }

    return (
        <div>
            <Header
                DashboardHeading="STP Maintainance"
            />
            <div className="wrapper">
                <Sidebar />
                <div className="content">
                    {/* <!-- [ breadcrumb ] start --> */}
                    <div className="page-header ">
                        <div className="page-block">
                            <div className="row align-items-center">
                                <div className="col-md-12">
                                    {/* <div className="page-header-title">
                                        <h5 className="ps-2 data_mob">MASTER */}

                                    {/* <span className="float-end fs-6">
                                                <Select
                                                // isClearable
                                                // isRtl={isRtl}
                                                isSearchable
                                                maxMenuHeight={150}
                                                value={{ value: SelectWard.ID, label: SelectWard.Label }}
                                                onChange={(e) => {
                                                    e ?
                                                        setSelectWard({ ...SelectWard, ID: e.value, Label: e.label })
                                                        :
                                                        setSelectWard({ ...SelectWard, ID: 0, Label: "Select..." })

                                                }}
                                                options={SelectWard.DDL}
                                            />

                                            </span> */}
                                    {/* </h5>

                                    </div> */}

                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <!-- [ Main Content ] start --> */}
                    <div className='data_mob'>
                        <div className="row m-1 pb-4 master_border">
                            <div className='mt-2'>
                            <h5>Machinery Details Master</h5>
                            <div className="float-end butt">
                                {/* <i class="fa-solid fa-plus add_btn" style={{ color: "#010813", fontSize: '17px' }}><span className="ml-2">Add</span></i> */}
                                <button type="button" className="btn btn-primary float-end ml-1">Export</button>
                                {/* 
                                        <SeweragePipelinePopup
                                            open={SewerageMasterPopupShow}
                                        /> */}
                                <i className="fa-solid fa-plus float-end btn btn-secondary"
                                    style={{ color: "white" }}
                                    onClick={handleAddOnClick}
                                >
                                    <text className="ml-2 poppins">Add</text>
                                </i>
                            </div>
                            </div>
                            <div className="row m-0 pt-1">
                                <div className="col-12 py-0 rounded rounded-2 shadow"
                                    style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                    <div className="col-12">

                                        <div className="row py-1 rounded2">
                                            <div className="col-lg-3 col-md-6">
                                                <label for=""><b>Ward :</b></label>
                                                <Select
                                                    // isClearable
                                                    // isRtl={isRtl}
                                                    // className="ddl_width"
                                                    isSearchable
                                                    maxMenuHeight={150}
                                                    value={{ value: Ward.ID, label: Ward.Label }}
                                                    onChange={(e) => {
                                                        e ?
                                                            setWard({ ...Ward, ID: e.value, Label: e.label })
                                                            :
                                                            setWard({ ...Ward, ID: 0, Label: "Select..." })

                                                    }}
                                                    options={Ward.DDL}
                                                />

                                            </div>

                                            <div className="col-lg-3 col-md-6">
                                                <label for=""><b>Mach Equipment Type :</b></label>
                                                <Select
                                                    // isClearable
                                                    // isRtl={isRtl}
                                                    // className="ddl_width"
                                                    isSearchable
                                                    maxMenuHeight={150}
                                                    value={{ value: MachEquipmentType.ID, label: MachEquipmentType.Label }}
                                                    onChange={(e) => {
                                                        e ?
                                                            setMachEquipmentType({ ...MachEquipmentType, ID: e.value, Label: e.label })
                                                            :
                                                            setMachEquipmentType({ ...MachEquipmentType, ID: 0, Label: "Select..." })

                                                    }}
                                                    options={MachEquipmentType.DDL}
                                                />

                                            </div>

                                            <div className="col-lg-3 col-md-6">
                                                <label for=""><b>Machinery Details :</b></label>
                                                <Select
                                                    // isClearable
                                                    // isRtl={isRtl}
                                                    // className="ddl_width"
                                                    isSearchable
                                                    maxMenuHeight={150}
                                                    value={{ value: MachineryDetails.ID, label: MachineryDetails.Label }}
                                                    onChange={(e) => {
                                                        e ?
                                                            setMachineryDetails({ ...MachineryDetails, ID: e.value, Label: e.label })
                                                            :
                                                            setMachineryDetails({ ...MachineryDetails, ID: 0, Label: "Select..." })

                                                    }}
                                                    options={MachineryDetails.DDL}
                                                />

                                            </div>

                                            <div className="col-12 col-md-6 col-lg-1 mt-lg-4 mt-md-4 mt-1" >
                                                <button type="button"
                                                    className="btn-clear btn btn-primary"
                                                >Clear</button>

                                            </div>

                                        </div>
                                        <div className="row mob_table table-responsive pt-1">

                                            <table id="totalordergenerated"
                                                cellPadding="0"
                                                cellSpacing="0"
                                                border="0"
                                                className="table table-bordered">

                                                <thead>
                                                    <tr>
                                                        <th className="sr_no_col">Sr No.</th>
                                                        <th>Prabhag No</th>
                                                        <th>Mach Equipment Type</th>
                                                        <th>Machinery Details</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td style={{ textAlign: "center" }}>1</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td>
                                                            <span>
                                                                <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                    style={{ cursor: 'pointer' }}
                                                                    onClick={() => handleEditOnClick()}
                                                                >
                                                                </i>
                                                            </span>
                                                            <span>
                                                                <DeletePopup
                                                                    open={DeletePopupShow}
                                                                // item={item}
                                                                // handleDeleteApi={handleDeleteApi}
                                                                />
                                                            </span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>

                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                {
                    STPMachineryDetailsMasterPopupShow ?
                        <STPMachineryDetailsMasterPopup
                            open={STPMachineryDetailsMasterPopupShow}
                            popupHeading="Work Name"
                            // handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                        // Flag={apiFlag}
                        // rowData={rowData}
                        />
                        : <></>
                }
            </div>
        </div>



    )
}